import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminMenus() {
  return (
    <AdminCrud
      title="Menus"
      resource="menus"
      initialItem={{ status: "published", order: 0, external: false }}
      fields={[
        { name: "label", label: "Rótulo (texto do menu)", required: true },
        { name: "url", label: "URL / caminho", required: true, help: "Ex: /servicos ou https://externo.com" },
        { name: "icon", label: "Ícone (lucide-react)" },
        { name: "order", label: "Ordem", type: "number" },
        { name: "external", label: "É link externo?", type: "checkbox", help: "Abre em nova aba" },
      ]}
      columns={[
        { name: "label", label: "Rótulo" },
        { name: "url", label: "URL" },
        { name: "order", label: "Ordem" },
      ]}
    />
  );
}
